import React, { Component } from 'react';
import {Modal} from 'carbon-components-react';
import  Select  from 'react-select';
import { toast } from 'react-toastify';
import { Breadcrumb, Card } from '../../../../components';

import {
  insertDmService,
  getByDmService,
  updateDmService,
  deleteDmService,
} from '../../../../services/Api';

class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      name: '',
      description: '',
      labelForm: 'Nome',
      placeForm: 'Digite aqui o nome da categoria',
      openMdDelete: false,
      selectedItemType: null

    };
  }

  componentWillMount() {
    this.managerVisited();
    this.getItem();
  }

  managerVisited = () => {
    const { match: propMatch } = this.props;
    const urlVisited = propMatch.url;
    const sac = urlVisited.match(/sac/);
    if (sac) {
      this.setState({          
        selectedItemType: {id: 2, label: "sac"}
      });
    } else {
      this.setState({
        selectedItemType: {id: 1, label: "mensagem"}
      });
    }
  };

  getItem = async () => {
    const { match } = this.props;
    const urlId = match.params && match.params.id;
    const result = await getByDmService('/ModeloCategoria/Get', urlId);
    const { ativo, descricao, nome} = result;
    this.setState({
      active: ativo,
      name: nome,
      description: descricao,
    });
  };

  onToogle = () => {
    const { match } = this.props;
    const { active } = this.state;
    // const urlId = match.params && match.params.id;
    this.setState(
      prevState => ({
        active: !prevState.active,
      }),
      async () => {
        try {
          await updateDmService('ModeloCategoria/AlteraStatus', match.params.id, null);
        } catch (e) {
          this.setState({ active });
          toast.warn('Ocorreu uma falha ao tentar trocar o status do item');
        }
      },
    );
  };

  onChangeText = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onChangeManage = event => {
    this.setState({
      selectedItemType: { id: event.id, label: event.label },
    });
  };

  saveCategory = async e => {
    e.preventDefault();
    const { name, description, selectedItemType } = this.state;
    const urlReturn = selectedItemType.id === 1 ? "/admin/modelos-mensagem/categorias/mensagem" : "/admin/modelos-mensagem/categorias/sac"
    const { match, history } = this.props;
    const urlId = match.params && match.params.id;
    
    const urlEdit = `/ModeloCategoria`;

    const formData = {
      tipo: selectedItemType.id, 
      nome: name,
      descricao: description,
    };
    
    try {
      if (urlId) {
        await updateDmService(urlEdit, urlId, formData);
        history.push(urlReturn);
        toast.success('Edição realizada com sucesso.');
      } else {
        await insertDmService(urlEdit, formData);
        history.push(urlReturn);
        toast.success('Categoria salva com sucesso.');
      }
    } catch (error) {
      toast.warn('Desculpe-nos. Ocorreu alguma falha ao tentar salvar os dados');
    }
  };


  modalDelete = () => {
    this.setState(prevState => ({
      openMdDelete: !prevState.openMdDelete,
    }));
  };

  delete = async () => {
    const { match, history } = this.props;
    const urlId = match.params && match.params.id;

    try {
      await deleteDmService('/ModeloCategoria/Get', urlId);
      toast.success('Deletado conforme o solicitado.');
      history.goBack();
    } catch (error) {
      toast.error('Um erro inesperado ocorreu ao tentar deletar');
    }
  };

  onChangeCheck = (val, id, event) => {
    this.setState({ [event.target.name]: val });
  };

  render() {
    const {
      name, 
      description, 
      labelForm, 
      placeForm, 
      openMdDelete,
      selectedItemType
    } = this.state;

    const { history, match } = this.props;
    const urlId = match.params && match.params.id;

    return (
      <div>
        {urlId ? (
          <Breadcrumb
            title="Editar categoria"
            description="Gerencie categorias de modelos de mensagem."
          
            renderLeft={(() => (
              <div className="breadcrumb-left-actions pointer" onClick={() => history.goBack()}>
                <svg width="16" height="14" viewBox="0 0 16 14">
                  <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                </svg>
              </div>
            ))()}
          />
        ) : (
          <Breadcrumb
            title="Criar categoria"
            description="Crie categorias de modelos de mensagem."
            renderLeft={(() => (
              <div className="breadcrumb-left-actions pointer" onClick={() => history.goBack()}>
                <svg width="16" height="14" viewBox="0 0 16 14">
                  <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                </svg>
              </div>
            ))()}
          />
        )}

        <Card className="center-box">
          <form onSubmit={this.saveCategory}>
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label">Selecione o tipo</label>
                <Select
                  className="search-dm"
                  name="grupos"
                  options={[{id: 1, label: "mensagem"}, {id: 2, label: "sac"}]}
                  required
                  value={selectedItemType}
                  onChange={e => this.onChangeManage(e)}
                  placeholder="Selecione o tipo"
                  isClearable={false}
                  isSearchable
                />
              </div>
            </div>
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label v-md-margin">{labelForm}</label>
                <input
                  type="text"
                  className="bx--text-input"
                  required
                  placeholder={placeForm}
                  name="name"
                  value={name}
                  onChange={this.onChangeText}
                />
              </div>
            </div>          
            <div className="bx--row mg-left-20">
              <div className="bx--col-xs-12 bx--col-md-6">
                <div className="bx--form-item">
                  <label className="bx--label v-md-margin">Descrição </label>
                  <textarea
                    className="bx--text-area"
                    rows="4"
                    cols="50"
                    required
                    placeholder="Digite aqui a descrição"
                    name="description"
                    value={description}
                    onChange={this.onChangeText}
                  />
                </div>
              </div>
            </div>
            <div className="bx--row mg-left-20 ">
              <div className="bx--col-xs-12 v-md-margin v-lg-margin">
                <button tabIndex="0" className="bx--btn btn-secondary-color" type="submit">
                  Salvar
                </button>
                <button
                  tabIndex="0"
                  className="h-sm-margin bx--btn btn-secondary-outlined"
                  type="button"
                  onClick={() => history.goBack()}
                >
                  Cancelar
                </button>
              </div>
            </div>
          </form>
        </Card>

        <Modal
          className="some-class"
          open={openMdDelete}
          modalHeading="Remover Item"
          primaryButtonText="Tenho certeza"
          secondaryButtonText="Cancelar"
          iconDescription="Cancelar e fechar"
          onRequestClose={() => this.modalDelete()}
          onRequestSubmit={() => this.delete()}
        >
          <p className="bx--modal-content__text">Você tem certeza que deseja deletar este item?</p>
        </Modal>
      </div>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/screens/admin/MessageModels/CategorysMessageModels/Edit.js